import { useEffect, useRef } from 'react';
import type { EnderecoPorCep } from '../types/Formulario';

/** Escreve só em campo vazio ou ainda igual ao último valor da busca (R16); `set` recebe o novo valor. */
export type Escrever = (
  campo: string,
  atual: string,
  novo: string,
  set: (v: string) => void,
  forcar?: boolean,
) => void;

/**
 * Aplica o endereço da busca no formulário (R16). Guarda por campo o último valor vindo da busca;
 * os valores iniciais contam como "ainda não editados". Número e complemento nunca passam por aqui (R10).
 */
export function useAplicarCep(
  endereco: EnderecoPorCep | undefined,
  iniciais: Record<string, string>,
  aplicar: (e: EnderecoPorCep, escrever: Escrever) => void,
) {
  const ultimo = useRef<Record<string, string>>({ ...iniciais });
  const aplicarRef = useRef(aplicar);
  aplicarRef.current = aplicar;

  useEffect(() => {
    if (!endereco) return;
    aplicarRef.current(endereco, (campo, atual, novo, set, forcar) => {
      if (!forcar && atual !== '' && atual !== ultimo.current[campo]) return;
      ultimo.current[campo] = novo;
      set(novo);
    });
  }, [endereco]);
}
